import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { formatDate } from "../../Utils/Utils";
import { Button } from "primereact/button";

const DocumentArchiveTable = ({documents, lazyState, onPage, totalRecords, toast}) => {
    return (<DataTable value={documents} lazy rows={lazyState.rows} paginator onPage={onPage} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} first={lazyState.first}
        emptyMessage="Документів не знайдено">
        <Column field="template_name" header="Назва документу" />
        <Column field="document_url" header="Посилання" body={(rowData) => <a target="_blank" rel="noopener noreferrer" href={rowData.document_url}>{rowData.template_name}_{rowData.created_at}</a>} />
        <Column field="created_at" header="Створено" body={(rowData) => formatDate(rowData.created_at)} />
        <Column body={(rowData) => <Button icon="pi pi-copy" type="button" severity="secondary" text onClick={() => {
            navigator.clipboard.writeText(rowData.document_url);
            toast.current.show({ severity: "secondary", summary: "Посилання скопійовано в буфер обміну", life: 1500 });
            }}/>} />
    </DataTable>)
}

export default DocumentArchiveTable;